<template>
	<form class="new-user-row" autocomplete="off">
		<ja-dropdown
			v-model="clusterSelection"
			class="form-dropdown"
			:options="cmsCareerClusters"
			name="clusters"
			:label="$t('clusters')"
		></ja-dropdown>
		<ja-dropdown
			v-model="jobSelection"
			class="form-dropdown"
			:options="uniqueCareers"
			name="job"
			:label="$t('job')"
			:disabled="uniqueCareers.length > 0 ? false : true"
		></ja-dropdown>
		<div class="new-user-buttons">
			<ja-button
				name="save"
				class="small btn-done-add-student"
				@click.native.prevent="saveStudents"
				>{{ $t('save') }}</ja-button
			>
		</div>
	</form>
</template>

<script>
import gql from 'graphql-tag';
import Dropdown from '@/components/ui/form/Dropdown';
import UserData from '@/mixins/UserData';
import Button from '@/components/ui/Button';

export default {
	name: 'AddStudent',
	components: {
		jaDropdown: Dropdown,
		jaButton: Button
	},
	mixins: [UserData],
	props: {
		student: {
			type: Object,
			default: () => {}
		},
		facilityId: {
			type: Number,
			default: null
		}
	},
	data() {
		return {
			clusterSelection: null,
			jobSelection: null,
			cmsCareerClusters: [],
			skipQuery: true,
			uniqueCareers: [],
			selectedJob: null
		};
	},
	apollo: {
		cmsCareerClusters: {
			query: gql`
				query clusters($jtWhere: String!, $careerWhere: String!) {
					cmsCareerClusters(
						where: "CmsCareers.Count(it.isActive=\\"true\\")>0"
					) {
						name
						careerCluster_ID
						imageBase64
						cmsCareers(where: $careerWhere) {
							career_ID
							name
							description
							education
							interests
							describeSkills
							skills
							expectedDuties
							outlook
							jobSatisfaction
							cmsCareerJobTitles(
								where: $jtWhere
								order: "CmsLifeStage.DisplayOrder"
							) {
								cmsLifeStage {
									displayOrder
								}
								jobTitle
								salary
								careerJobTitle_ID
							}
							cmsEducation {
								education_ID
							}
						}
					}
				}
			`,
			variables() {
				return {
					jtWhere: `isActive="true" && lifeStage_ID != "${this.constants.teenagerAdultLifeStageGuid}"`,
					careerWhere: `isActive="true" && CmsCareerJobtitles.Count(it.isActive="true")==4 && facility_ID = "${this.facilityId}"`
				};
			},
			update(data) {
				this.$store.commit('setLoading', false);
				return data.cmsCareerClusters;
			},
			skip() {
				return this.skipQuery;
			}
		}
	},
	computed: {
		constants() {
			return this.$store.getters.constants;
		}
	},
	watch: {
		constants() {
			this.skipQuery = false;
		},
		clusterSelection(selectedIndex) {
			const LifeStageYoungAdult = 1;

			const selectedCluster = this.cmsCareerClusters[selectedIndex];

			if (selectedCluster && selectedCluster.cmsCareers) {
				this.uniqueCareers = selectedCluster.cmsCareers
					.map(career => {
						const filteredJobTitles = career.cmsCareerJobTitles.filter(
							jobTitle =>
								jobTitle.cmsLifeStage.displayOrder === LifeStageYoungAdult
						);

						if (filteredJobTitles.length > 0) {
							const modifiedName = filteredJobTitles[0].jobTitle;
							return {
								...career,
								name: modifiedName,
								cmsCareerJobTitles: filteredJobTitles
							};
						}
					})
					.filter(career => career !== null);
			}
		},
		jobSelection(indexJob) {
			this.selectedJob = this.uniqueCareers[indexJob];
		}
	},
	mounted() {
		if (this.constants) {
			this.skipQuery = false;
		}
		this.$store.commit('setLoading', true);
	},
	methods: {
		updateFormData() {
			this.$emit('addCareer', {
				jobSelection: this.selectedJob
			});
		},
		async saveStudents() {
			if (this.selectedJob !== null) {
				this.updateFormData();
				this.clusterSelection = null;
				this.uniqueCareers = [];
			}
		}
	}
};
</script>
<style lang="scss" scoped>
.form-dropdown {
	width: 320px;
	display: flex;
	flex-direction: column;
	margin-top: 16px;
	::v-deep .options-list .option {
		min-height: 40px;
		line-height: 25px;
		padding-left: 16px;
		padding-bottom: 12px;
		padding-top: 12px;
		text-align: left;
	}
}

.new-user-buttons {
	display: flex;
	align-items: center;
	flex-direction: column;
	margin-top: 32px;
	button {
		margin-bottom: 16px;
	}
}
</style>
